
import { Link } from "react-router-dom";
import { ProductCard } from "@/components/ProductCard";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const AVOIPOptions = () => {
  const { t } = useLanguage();
  
  const options = [
    {
      id: "1gb",
      name: t('1gb.solutions'),
      description: t('1gb.description'),
      image: "/lovable-uploads/32246336-5317-4179-8959-9ffd3aa2a183.png",
      slug: "1gb",
      link: `/group/avoip?speed=1gb`,
      showLogos: true,
    },
    {
      id: "10gb",
      name: t('10gb.solutions'),
      description: t('10gb.description'),
      image: "/lovable-uploads/4b4c16d4-840e-4ac6-a4d2-a21b6a6ce06e.png",
      slug: "10gb",
      link: `/group/avoip?speed=10gb`,
      showLogos: true,
    },
    {
      id: "vpx-accessories",
      name: t('1gb.vpx.accessories'),
      description: t('vpx.accessories.description'),
      image: "/lovable-uploads/dea779a6-e575-4fdf-a2a5-13dd3f221755.png",
      slug: "vpx-accessories",
      link: `/group/avoip?speed=vpx-accessories`,
    },
    {
      id: "software",
      name: t('software'),
      description: t('software.description'),
      image: "/lovable-uploads/609cd1fc-ebb7-4b5b-8731-f0e7c5722774.png",
      slug: "software",
      link: `/group/avoip?speed=software`,
    },
  ];

  const threeLogos = [
    "/lovable-uploads/06fe1782-824d-4c1d-9254-aab5065810bf.png", // Dante
    "/lovable-uploads/dc50d6e6-ebe6-4761-a9a7-4221a9044168.png", // AURACAST
    "/lovable-uploads/67aa6f30-ffde-42a8-b227-d61c7af63ddc.png"  // AES
  ];

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="mb-8">
        <Link
          to="/"
          className="mb-8 inline-flex items-center text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          {t('back.to.categories')}
        </Link>
        <h1 className="mb-4 text-3xl font-bold tracking-tight">
          {t('avoip.solutions')}
        </h1>
        <p className="text-lg text-muted-foreground">
          {t('choose.network.speed')}
        </p>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 max-w-4xl mx-auto">
        {options.map((option) => (
          <div key={option.id} className="h-[400px] w-full animate-fade-up">
            <div className="h-full w-full bg-white rounded-md shadow hover:shadow-md transition-shadow">
              <Link 
                to={option.link}
                className="flex flex-col h-full p-6"
              >
                <div className="text-center mb-4">
                  <h3 className="text-xl font-semibold tracking-tight text-foreground">
                    {option.name}
                  </h3>
                </div>
                
                <div className="flex-grow flex flex-col items-center justify-center">
                  <div className="relative aspect-square w-full max-w-[240px] overflow-hidden rounded-lg bg-background/50 mb-4">
                    <img
                      src={option.image}
                      alt={option.name}
                      className="h-full w-full object-scale-down p-4"
                      loading="lazy"
                      onError={(e) => {
                        console.error(`Failed to load image: ${option.image}`);
                        e.currentTarget.src = "/placeholder.svg";
                      }}
                    />
                  </div>
                  
                  {/* Aurora Logo */}
                  <div className="w-24 h-auto flex items-center justify-center mb-3">
                    <img
                      src="/lovable-uploads/29f5a874-3103-490e-ae29-e107bf621df9.png"
                      alt="Aurora Logo"
                      className="w-full h-auto object-contain"
                    />
                  </div>

                  {/* Three logos row for 1Gb and 10Gb solutions only */}
                  {option.showLogos && (
                    <div className="flex items-center justify-center gap-3 w-full max-w-[200px]">
                      {/* Dante logo - larger and positioned left */}
                      <div className="w-14 h-10 flex items-center justify-start">
                        <img
                          src={threeLogos[0]}
                          alt="Dante Logo"
                          className="max-w-full max-h-full object-contain"
                        />
                      </div>
                      {/* AURACAST logo - larger and centered */}
                      <div className="w-14 h-10 flex items-center justify-center">
                        <img
                          src={threeLogos[1]}
                          alt="AURACAST Logo"
                          className="max-w-full max-h-full object-contain"
                        />
                      </div>
                      {/* AES logo - smaller and positioned right */}
                      <div className="w-10 h-8 flex items-center justify-end">
                        <img
                          src={threeLogos[2]}
                          alt="AES Logo"
                          className="max-w-full max-h-full object-contain"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AVOIPOptions;
